"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonProfileModal = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const OktonPlatformProvider_1 = require("../../platform/OktonPlatformProvider");
const OktonProfileModal = ({ isOpen, onClose }) => {
    const { user, system, businessContext } = (0, OktonPlatformProvider_1.useOktonPlatform)();
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    const cardBg = (0, react_1.useColorModeValue)('gray.50', 'gray.700');
    const muted = (0, react_1.useColorModeValue)('gray.500', 'gray.300');
    if (!user)
        return null;
    return (react_2.default.createElement(react_1.Modal, { isOpen: isOpen, onClose: onClose, size: "xl" },
        react_2.default.createElement(react_1.ModalOverlay, null),
        react_2.default.createElement(react_1.ModalContent, { bg: bg, rounded: "2xl" },
            react_2.default.createElement(react_1.ModalHeader, null, "Perfil"),
            react_2.default.createElement(react_1.ModalCloseButton, null),
            react_2.default.createElement(react_1.ModalBody, { pb: "6" },
                react_2.default.createElement(react_1.Flex, { align: "center", mb: "6" },
                    react_2.default.createElement(react_1.Avatar, { size: "lg", name: user.name, src: user.avatarUrl, mr: "4" }),
                    react_2.default.createElement(react_1.Box, null,
                        react_2.default.createElement(react_1.Text, { fontWeight: "semibold", fontSize: "lg" }, user.name),
                        react_2.default.createElement(react_1.Text, { color: muted, fontSize: "sm" }, user.email || 'E-mail não informado'))),
                react_2.default.createElement(react_1.Divider, { mb: "5" }),
                react_2.default.createElement(react_1.SimpleGrid, { columns: { base: 1, md: 2 }, spacing: "3" },
                    react_2.default.createElement(react_1.Box, { bg: cardBg, p: "4", rounded: "xl" },
                        react_2.default.createElement(react_1.Text, { fontSize: "xs", color: muted }, "Sistema"),
                        react_2.default.createElement(react_1.Text, { fontWeight: "medium" }, system.name)),
                    react_2.default.createElement(react_1.Box, { bg: cardBg, p: "4", rounded: "xl" },
                        react_2.default.createElement(react_1.Text, { fontSize: "xs", color: muted }, "Usu\u00E1rio"),
                        react_2.default.createElement(react_1.Text, { fontWeight: "medium" }, user.id)),
                    (businessContext === null || businessContext === void 0 ? void 0 : businessContext.companyName) && react_2.default.createElement(react_1.Box, { bg: cardBg, p: "4", rounded: "xl" },
                        react_2.default.createElement(react_1.Text, { fontSize: "xs", color: muted }, "Empresa"),
                        react_2.default.createElement(react_1.Text, { fontWeight: "medium" },
                            businessContext.companyId,
                            " - ",
                            businessContext.companyName)),
                    (businessContext === null || businessContext === void 0 ? void 0 : businessContext.branchName) && react_2.default.createElement(react_1.Box, { bg: cardBg, p: "4", rounded: "xl" },
                        react_2.default.createElement(react_1.Text, { fontSize: "xs", color: muted }, "Filial"),
                        react_2.default.createElement(react_1.Text, { fontWeight: "medium" },
                            businessContext.branchId,
                            " - ",
                            businessContext.branchName)))))));
};
exports.OktonProfileModal = OktonProfileModal;
//# sourceMappingURL=index.js.map